import EmptyImage from "../../../assets/emptystats/empty.svg";

import { textConstants } from "./utils";
import { useMediaQuery } from "@mui/material";
import { CreateNewFormButton } from "../Buttons";

import {
  RootContainer,
  ImageContainer,
  PreviewImage,
  TextContainer,
  SubHeaderText,
  HeaderText,
  ButtonContainer,
} from "./Styled";
import CreateNewFormPopup from "../../Popup/createNewFormPopup";
import { useState } from "react";

export default function ListEmpty() {
  const isLessThan1024 = useMediaQuery("(max-width:1025px)");
  const [open, setOpen] = useState<boolean>(false)

  return (
    <RootContainer>
      <ImageContainer>
        <PreviewImage isLessThan1024={isLessThan1024} src={EmptyImage} />
      </ImageContainer>
      <TextContainer>
        <SubHeaderText>{textConstants.nothingToShow}</SubHeaderText>
        <HeaderText>{textConstants.createForm}</HeaderText>
      </TextContainer>
      <ButtonContainer>
        <CreateNewFormButton onClick={() => setOpen(true)} />
      </ButtonContainer>
      {open && <CreateNewFormPopup open={open} setOpen={setOpen} />}
    </RootContainer>
  );
}
